const routes = [
  { name: 'login' },
  { name: 'register' },
  { name: 'forgot-password' },
  { name: 'fb-connect' },
]

export default routes
